import { requestJson } from '../common/http';
import type { WorkItemSearchView } from './models';

type SearchWorkItemsResponse = {
    items: WorkItemSearchView[];
};

export const searchWorkItems = async (query: string): Promise<WorkItemSearchView[]> => {
    const response = await requestJson<SearchWorkItemsResponse>({
        method: 'GET',
        path: '/work-items',
        query: { q: query.trim() },
    });
    return response.items;
};
